import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';

class ShareRequests extends Component {
    constructor(props) {
        super(props)
        this.state={
            share_data :props.shareData,
        };
        this.ChangeStatus = this.ChangeStatus.bind(this);
    }

    componentDidMount () {

    }   

    ChangeStatus(status,note_id){
        let learnerID   = Common.getUserData("id", true);       

        fetch(Config.domainUrl+'writing-pad/change-status', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':'Bearer ' +Common.getTokenData()
            },
            body: JSON.stringify({
                learner_id: learnerID,
                status: status,
                note_id:note_id,
            })
            }).then((response) => response.json()).then((responseJson) => {
                if(responseJson.status!=0){
                    Common.message(responseJson.message,'','success');
                    this.props.changedStatus('changed');
                }
                else{
                    Common.message(responseJson.message,'','error');
                }
                                 
                        
            });
    }



    componentWillReceiveProps(nextProps) {
        if(nextProps.shareData!=undefined){
            this.setState({
                share_data : nextProps.shareData
            })
        }
    } 

    render () {
        let share = [];
        if(this.state.share_data != undefined || this.state.share_data != null){
         share = this.state.share_data.map((sha,i)=>{
            return(
                    <tr key={`share_${i}`}>
                        <td>{sha.learner_name}</td>
                        <td>{sha.status}</td> 
                        <td><input type="button" name="Approve" onClick={()=>this.ChangeStatus(1,sha.share_notes_id)}  value="Approve" alt="Approve" title="Approve" style={{float:'none'}}/>
                            <input type="button" name="Reject"  onClick={()=>this.ChangeStatus(2,sha.share_notes_id)} value="Reject" alt="Reject" title="Reject" className="button-cancel" style={{float:'none'}}/></td>
                    </tr>
                )
        })
     }

        return (
            <div id="sharedlr_view" className="table-cont71">
              <table cellPadding="0" cellSpacing="0" border="0" width="100%" className="myjourney-table">
                <thead>
                  <tr>
                    <th>Share request from</th>
                    <th>Status</th>
                    <th>Change Status</th>
                  </tr>
                </thead>
                <tbody>
                    {(!share.length)?<tr><td colSpan="4">No datas found.</td></tr>:share}
                </tbody>
              </table>
            </div>
        )
    }
}

export default ShareRequests


// WEBPACK FOOTER //
// ./src/lr_dlr_components/notepad_partials/ShareRequests.js